exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-item[data-v-3347cba4] {\n  text-decoration: none;\n}\n.menu-item.disabled[data-v-3347cba4] {\n  color: #dedede;\n  cursor: default;\n}\n.menu-item.disabled[data-v-3347cba4]:hover {\n  background-color: white !important;\n  color: #dedede !important;\n  text-decoration: none;\n  cursor: default;\n  border-radius: 20px !important;\n  box-shadow: 2px 2px 8px #ccc !important;\n  padding: 15px !important;\n}", ""]);

// exports
